import api from '../api/api';
import { ApiResponse } from '../api/api';
import apiUrls from '../api/apiUrls';

export const getCustomerList = async (search: string, plantId: string): Promise<any[]> => {
    // Only call API if plantId is present and search is at least 3 characters
    if (!plantId || search.trim().length < 3) {
        return [];
    }
    try {
        const res: ApiResponse<any[]> = await api.get(apiUrls.GetCustomerDetails, {
            params: {
                PlantId: plantId,
                search
            },
        });
        return res.Data || [];
    } catch (error: any) {
        throw new Error(error instanceof Error ? error.message : String(error));
    }
};

export default {
    getCustomerList,
};